(function () {
  function removeLocalLiquidPlaceholder() {
    if (!document.body) return;
    Array.prototype.slice.call(document.body.childNodes).forEach(function (node) {
      if (node.nodeType !== 3 || !node.nodeValue) return;
      if (node.nodeValue.indexOf("{{ content_for_header }}") === -1) return;
      node.nodeValue = node.nodeValue.replace("{{ content_for_header }}", "");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", removeLocalLiquidPlaceholder, { once: true });
  } else {
    removeLocalLiquidPlaceholder();
  }
})();
